import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class S3ApiService {
  private readonly http: HttpClient;

  constructor(backend: HttpBackend) {
    this.http = new HttpClient(backend);
  }

  upload(url: string, formData: FormData): Observable<void> {
    return this.http.post<void>(url, formData);
  }

  uploadPart(url: string, part: Blob): Observable<HttpEvent<any>> {
    return this.http.put(url, part, {
      reportProgress: true,
      observe: "events",
    });
  }
}
